export default __webpack_public_path__ + "static/media/loading.90672f1d.gif";